import { Box, Collapse, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { LogisticaFiltros } from "./components/LogisticaFiltros"
import { GetReporteLogistica } from "../../../hooks/reporteLogistica";
import { useLoading } from "../../../components/Loading/useLoading";
import React, { useContext, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import moment from "moment";
import { ThemeContext } from "@emotion/react";
import { exportToExcel } from "react-json-to-excel";

export const ReporteLogisticaIndex = () => {

  const theme = useContext(ThemeContext);
  const { setAppLoading } = useLoading();
  const { getReporteLogisticaMutation } = GetReporteLogistica();
  const [dataLogistica, setDataLogistica] = useState([]);


  const search = (body) => {
    setAppLoading(true)
    getReporteLogisticaMutation(body, {
      onSuccess: (data) => {
        console.log(data);
        setDataLogistica(data);
      },
      onError: (error) => {
        console.log(error);
        setDataLogistica([]);
      },
      onSettled: () => {
        setAppLoading(false);
      }
    })
  }

  function SecondRow(props) {
    const { row } = props;

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.tipo}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.folio}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {moment(row?.fecha)?.format('DD-MM-YYYY')}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.contenedores}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.total}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.usuario}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = () => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla()}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.empresa}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.empresaCodigo}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.part_nombre}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.part_codigoentrada}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidadEntrada}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidadShipper}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidadApartado}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidadAjuste}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidadCuarentena}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Tipo
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Folio
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Fecha
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Contenedores
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Total
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Responsable
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.entradas?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                    {row?.shippers?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                    {row?.apartadoSalida?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                    {row?.ajuste?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                    {row?.cuarentena?.map((secRow, index) => (
                      <SecondRow key={index} row={secRow} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const exportToExcelGeneral = (inicio, fin) => {

    let data = dataLogistica.map((item) => {
      return {
        cliente: item.empresa,
        codigo_cliente: item.empresaCodigo,
        parte: item.part_nombre,
        codigo_entrada: item.part_codigoentrada,
        ingresos: item.cantidadEntrada,
        shipper: item.cantidadShipper,
        apartados_salida: item.cantidadApartado,
        ajuste: item.cantidadAjuste,
        cuarentena: item.cantidadCuarentena
      }
    });
    exportToExcel(
      data,
      `galus_logistica_general_${data[0].cliente}_${data[0].codigo_cliente}_${inicio}_a_${fin}`
    )
  }

  const exportToExcelDetalle = (inicio, fin) => {
    let data = dataLogistica.map((item) => {
      return [...item.entradas, ...item.shippers, ...item.apartadoSalida, ...item.ajuste, ...item.cuarentena]
    });
    data = data.flatMap(i => i);
    exportToExcel(
      data,
      `galus_logistica_detalle_${data[0].empresa}_${data[0].empresaCodigo}_${inicio}_a_${fin}`
    )
  }

  return (
    <Grid container spacing={0} sx={{ height: '87vh', alignContent: 'flex-start', overflowY: 'auto' }}>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start' }} className="center_item">
        <LogisticaFiltros key='filtros_r_turno' searchData={search} exportGeneral={exportToExcelGeneral} exportDetalle={exportToExcelDetalle} canDownXlsx={dataLogistica?.length > 0} />
      </Grid>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }} className="center_item">
        {
          dataLogistica.length > 0 &&
          <Paper
            style={{ maxHeight: '100vh', overflowY: "scroll", width: "100%" }}
            sx={{ boxShadow: "none" }}
          >
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead
                  sx={{
                    display: "table-head",
                    backgroundColor: theme.palette.primary.main,
                    fontWeight: 600,
                  }}
                >
                  <TableRow>
                    <TableCell align="center" sx={{ color: "white" }} />
                    <TableCell align="center" sx={{ color: "white" }}>
                      Cliente
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Código Cliente
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Parte
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Codigo Entrada
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Ingresos
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Shipper
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Apartados Salida
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Ajuste
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Cuarentena
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLogistica?.map((row, index) => (
                    <Row key={index} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        }
      </Grid>
    </Grid>
  )
}